module.exports = __webpack_public_path__ + "static/media/Rectangle 6567.8d6be0c4.svg";